import { redirect } from "react-router";
import { PAGES } from "src/configs/pages-urls";
import { convertFrameworkRoute } from "src/utils/routes";

const appStoreChildrenRoutes = [
	{
		path: `${PAGES.appStore.sub.app}/:id`,
		lazy: () =>
			import("src/module--app-store/pages/app.page").then(
				convertFrameworkRoute,
			),
	},
	{
		path: `${PAGES.appStore.sub.recipe}/:id`,
		lazy: () =>
			import("src/module--app-store/pages/recipe.page").then(
				convertFrameworkRoute,
			),
	},
];

export default [
	{
		path: "",
		loader: () => redirect(PAGES.appStore.sub.all),
	},
	{
		path: `${PAGES.appStore.path}/${PAGES.appStore.sub.app}/${PAGES.new}`,
		lazy: () =>
			import("src/module--app-store/pages/new-app.page").then(
				convertFrameworkRoute,
			),
	},
	{
		path: `${PAGES.appStore.path}/${PAGES.appStore.sub.app}/:id/${PAGES.edit}`,
		lazy: () =>
			import("src/module--app-store/pages/edit-app.page").then(
				convertFrameworkRoute,
			),
	},
	{
		path: `${PAGES.appStore.sub.all}`,
		lazy: () =>
			import("src/module--app-store/pages/apps.page").then(
				convertFrameworkRoute,
			),
		children: appStoreChildrenRoutes,
	},
	{
		path: `${PAGES.appStore.sub.builder}`,
		lazy: () =>
			import("src/module--app-store/pages/new-app.page").then(
				convertFrameworkRoute,
			),
	},
	{
		path: `${PAGES.appStore.sub.installed}`,
		lazy: () =>
			import("src/module--app-store/pages/installed-apps.page").then(
				convertFrameworkRoute,
			),
		children: appStoreChildrenRoutes,
	},
	{
		path: `${PAGES.appStore.sub.category}/:tagFilter`,
		lazy: () =>
			import("src/module--app-store/pages/apps.page").then(
				convertFrameworkRoute,
			),
		children: appStoreChildrenRoutes,
	},
];
